import React from 'react';
import { connect } from 'react-redux'
import DistribucionLimitesTarjeta from './DistribucionLimitesTarjeta';

//Connect entre el componente y las props y actions.
const DistribucionLimitesTarjetaContainer = connect()(DistribucionLimitesTarjeta);

export default DistribucionLimitesTarjetaContainer;
